<div class="products-family-route lifeislife-header-route">

  <div class="back">
    <a [routerLink]="['/products']"
       class="back-link"
    >
      <i class="fa fa-chevron-left"></i>
      <span>Retour à mes polices</span>
    </a>
  </div>

  <a [routerLink]="['/mandate']"
     class="sticky-button lifeislife-button-link mandate-request-action-button"
  >
    <span i18n>Transférer d'autres contrats vers LifeisLife</span>
  </a>

  <header>
    <h1>Mes produits {{familyLabel$ | async}}</h1>
  </header>

  <div class="products-family">
    <div class="results-list" *ngIf="(insuranceResults$ |async)?.count > 0; else emptyResults">
      <div *ngFor="let subscription of (insuranceResults$ | async)?.list">
        <cf-insurance-subscription-item [insuranceSubscription]="subscription"
        ></cf-insurance-subscription-item>
      </div>
    </div>
    <ng-template #emptyResults>
      <p class="empty-category">
        Aucun produit dans cette catégorie
      </p>
    </ng-template>
  </div>

  <div class="paginator">
    <p-paginator [alwaysShow]="false"
                 [first]="pagination.offset"
                 [rows]="pagination.length"
                 [totalRecords]="(insuranceResults$ | async)?.count"
                 (onPageChange)="onPageChange($event)"
    ></p-paginator>
  </div>

  <div class="call-to-action">
    <a class="lifeislife-button-link"
       (click)="onNewSourcingInfoRequestClick()"
    >
      Je voudrais plus d'informations sur d'autres produits {{familyLabel$ | async}}
    </a>

  </div>

  <cf-insurance-request-draft-dialog [ticket]="editingInsuranceInfoReaquestDraf$ | async"
  ></cf-insurance-request-draft-dialog>


</div>
